import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3bad4f0f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3bad4f0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad4f0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bad4f0f')) {
      api.createRecord('3bad4f0f', component.options)
    } else {
      api.reload('3bad4f0f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3bad4f0f&scoped=true", function () {
      api.rerender('3bad4f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/dashboard/index.vue"
export default component.exports